document.addEventListener('DOMContentLoaded', function () {

  const productJson = document.getElementById('emm-product-json');

  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);

  const variantSelect = document.querySelector('.emm-variant-select');
  const price = document.getElementById('emm-price');
  const comparePrice = document.getElementById('emm-compare-price');

  if (!variantSelect) return;

  function money(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(cents / 100);
  }

  function updateVariant() {

    const variant = product.variants.find(function (v) {
      return Number(v.id) === Number(variantSelect.value);
    });

    if (!variant) return;

    price.textContent = money(variant.price);

    if (
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {

      comparePrice.style.display = 'inline';

      comparePrice.textContent = money(
        variant.compare_at_price
      );

    } else {

      comparePrice.style.display = 'none';
      comparePrice.textContent = '';

    }

  }

  variantSelect.addEventListener('change', updateVariant);

  updateVariant();

});